























import StudentApplicationStatusComp from '../applicationSummary/StudentApplicationStatusComp.vue'
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'studentApplyNewestList',
  components: {
    StudentApplicationStatusComp
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) private datas!: any[];

}
